import React, { FC, useState } from 'react';
import { Feather } from '@expo/vector-icons';
import { FlatList, Modal, Pressable, TouchableOpacity, View } from 'react-native';

import { Body1Reg, Body2Reg, Caption1Bold } from '../../../config/designSystem/typography';
import { COLORS } from '../../../config/designSystem/Colors';
import { SPACING } from '../../../config/designSystem/Spacing';

interface SelectFieldProps {
  label: string;
  value: string;
  options: string[];
  onChange: (value: string) => void;
}

/**
 * The design's form dropdown: a white rounded field with the current value
 * and a chevron, opening a centered option sheet.
 */
export const SelectField: FC<SelectFieldProps> = ({
  label,
  value,
  options,
  onChange,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <View style={{ flex: 1, rowGap: SPACING['sp-8'] }}>
      {label ? <Caption1Bold color={COLORS.content.primary}>{label}</Caption1Bold> : null}
      <TouchableOpacity
        onPress={() => setOpen(true)}
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: COLORS.surface.contrast,
          borderRadius: SPACING['sp-12'],
          borderWidth: 1,
          borderColor: COLORS.border.secondary,
          paddingVertical: SPACING['sp-12'],
          paddingHorizontal: SPACING['sp-16'],
        }}
      >
        <Body1Reg>{value}</Body1Reg>
        <Feather name="chevron-down" size={18} color={COLORS.content.secondary} />
      </TouchableOpacity>
      <Modal visible={open} transparent={true} animationType="fade" onRequestClose={() => setOpen(false)}>
        <Pressable
          onPress={() => setOpen(false)}
          style={{
            flex: 1,
            backgroundColor: 'rgba(0,0,0,0.4)',
            justifyContent: 'center',
            alignItems: 'center',
            padding: SPACING['sp-24'],
          }}
        >
          <View
            style={{
              backgroundColor: COLORS.surface.contrast,
              borderRadius: SPACING['sp-16'],
              maxHeight: 420,
              width: 260,
              paddingVertical: SPACING['sp-8'],
            }}
          >
            <FlatList
              data={options}
              keyExtractor={item => item}
              renderItem={({ item }) => (
                <TouchableOpacity
                  onPress={() => {
                    onChange(item);
                    setOpen(false);
                  }}
                  style={{
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    paddingVertical: SPACING['sp-12'],
                    paddingHorizontal: SPACING['sp-16'],
                    backgroundColor: item === value ? COLORS.surface.accent : COLORS.surface.contrast,
                  }}
                >
                  <Body2Reg color={item === value ? COLORS.content.accent : COLORS.content.primary}>
                    {item}
                  </Body2Reg>
                  {item === value && (
                    <Feather name="check" size={16} color={COLORS.content.accent} />
                  )}
                </TouchableOpacity>
              )}
            />
          </View>
        </Pressable>
      </Modal>
    </View>
  );
};
